import { render } from "./_control_chart.vue?vue&type=template&id=80f4fc74&scoped=true"
import script from "./_control_chart.vue?vue&type=script&lang=js"
export * from "./_control_chart.vue?vue&type=script&lang=js"

import "./_control_chart.vue?vue&type=style&index=0&id=80f4fc74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f4fc74"]])

export default __exports__